"use client";

import React from "react";
import { Star, MapPin, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const reviews = [{
  id: 1,
  name: "Erez K.",
  location: "Parent",
  text: "Robert Cottone is, without a shadow of a doubt, the best tutor my kids have ever worked with and one of the finest educators I've met in my life. His tutoring has single handedly transformed my daughter's experience in math. My kid is a 'humanities' kid who attends one of the most rigorous academic high schools in the country, with a very intensive STEM emphasis. The school does not offer 'math for poets' and, before she began working with Mr. Cottone, it's fair to say my kid was lost. Now, entering her third year of working with him, she has (thanks to his help) turned into an A student in math. More important than her grades, she has acquired a confidence in mathematics that would have been impossibly elusive without Mr. Cottone's magnificently patient, clear explications and wonderful confidence-building manner. If you are looking for a one-in-a-million tutor for your kid in math, stop right here -- you've found him.",
  date: "Grade 11"
}, {
  id: 2,
  name: "Rebecca S.",
  location: "Parent",
  text: "Outstanding Math Tutor – Truly Made a Difference! We are incredibly grateful for the amazing support our math tutor has given our child the last few months before the AP Exam. With finals approaching and a lot of pressure to catch up, we were in need of someone who could make a real impact in a short period of time — and that’s exactly what we found.nRobert not only helped our child improve his grades but more importantly, helped them understand the subject in a way that school just hadn't. Concepts that once seemed confusing suddenly started to click, and we noticed a boost in both confidence and motivation. Robert's ability to explain things clearly, patiently, and in a way that connected with our child made all the difference. We truly feel that this tutor gave our child the tools to succeed, not just for the test, but long-term. Highly recommend to any parent looking for someone who can bring out the best in them!",
  date: "Grade 11"
}, {
  id: 3,
  name: "Kerrie S.",
  location: "Parent",
  text: "He really helped explain the concepts to my daughter and prompted her to work through the problem to find the solution. She very much enjoyed him as a tutor and is doing well right now in math. We will definitely be repeat clients!",
  date: "Grade 10"
}, {
  id: 4,
  name: "Rob A.",
  location: "Student",
  text: "Thank you for the extensive knowledge you had for the 4 math classes I needed to pass. Without your help, I know for a fact I wouldn’t have passed. You made math just make sense and I appreciate everything.",
  date: "College"
}, {
  id: 5,
  name: "Kannan V.",
  location: "Parent",
  text: "My son had a great experience with Mr. Cottone who helped him prepare for the AP Calculus BC exam. He was extremely helpful, making sure my son understood key concepts and guiding me through practice problems. The sessions were always productive, and his support made a big difference in my son’s confidence.",
  date: "Grade 12"
}, {
  id: 6,
  name: "Bobby G.",
  location: "Parent",
  text: "My son is currently in 7th grade and has had his fair share of challenges with grasping important math concepts. Unfortunately, when my son was in the 4th grade the pandemic hit and he was forced into virtual learning. During this time, he did not learn the integral math concepts he desperately needed to understand in order to excel mathematically after elementary. Enter Mr. Cottone. Since working with Mr. Cottone the entire Fall semester of 7th grade 2x/weekly , my son finished the semester with a 97% in math!! My fiancée and I were pleasantly surprised at how the As started rolling in just after my son's first month of working with Mr. Cottone. I could go on forever about how grateful we are to have found Mr. Cottone. He is punctual, professional, and most importantly really knows his stuff! I love how he uses technology to explain complex math concepts during the tutoring sessions as well. If you are in search for an A+ tutor there's no need to look anywhere else, Mr. Cottone is the only choice!",
  date: "Grade 7"
}, {
  id: 7,
  name: "Tatiana I.",
  location: "Parent",
  text: "Mr.Cottone has the ability to explain the math topics in an easy way which different from my son’s high school teacher. My son said, it’s very interesting that the material is so easy when Mr. Cottone explains, when our school teacher explains that sounds confusing and complicated. Mr. Cottone is helping my son to refresh, catch up and stay on track with the math classes. My son took already several classes with Mr Cottone in order to prepare himself for the math tests, and he is very satisfied with the tutoring classes and his progress.",
  date: "Grade 10"
}, {
  id: 8,
  name: "Jenn Y.",
  location: "Parent",
  text: "My daughter was struggling with understanding concepts in her math class. We were looking for a tutor that would help and Robert has exceeded our expectations. My daughter is more comfortable and enjoys math since working with Robert. She looks forward to her math sessions and has improved from a D to A+. Thanks Robert we are lucky to have you!",
  date: "Grade 9"
}, {
  id: 9,
  name: "Lamarr J.",
  location: "Parent",
  text: "My daughter was really struggling with the way the lesson plan was being taught, and after a couple of weeks of teaching herself to understand the material and still having some struggles with Pre-Cal we found Mr. Cottone, felt he would be a good match and set up a tutoring session with my daughter. After the first session she felt like Mr. Cottone, made it easy to understand the concepts being taught in class. Heading into the closing of the grading period she has maintained a 93%.",
  date: "Grade 11"
}, {
  id: 10,
  name: "Roberto A.",
  location: "Student",
  text: "After working with Mr. Cottone, I had a stronger understanding of the material and improved my test scores in calculus, linear algebra, and discrete math (undergrad and grad levels). I would definitely work with him again. He is a caring teacher and cares a lot about his student's success.",
  date: "College"
}, {
  id: 11,
  name: "Jessica D.",
  location: "Parent",
  text: "Mr.Cottone helped my son with Algebra 2 and preparing for his final exam. He has a way of explaining the concepts clearly that really helped my son understand them more fully. He went into his exam feeling much more confident and did well. We will be working with Mr. Cottone next year to help with Pre-Calculus and test prep.",
  date: "Grade 10"
}, {
  id: 12,
  name: "Nancy J.",
  location: "Parent",
  text: "Responded and set up an appt quickly to help study for a midterm, same day! and it is working!!!",
  date: "Grade 11"
}, {
  id: 13,
  name: "Jennifer G.",
  location: "Parent",
  text: "Easy to schedule and pay online. We sent pictures of work and he went through the questions and taught different ways to answer as teachers differ in style and he helped prepare for the SAT. We did 9th grade algebra.",
  date: "Grade 9"
}, {
  id: 14,
  name: "Manish G.",
  location: "Parent",
  text: "Great experience for my daughter studying AP Calculus. Mr Cottone is an excellent tutor!",
  date: "Grade 12"
}, {
  id: 15,
  name: "Ryan G.",
  location: "Parent",
  text: "Mr. Cottone has been great to work with. Accepting the need of a tutor was stressful in our household. Mr. Cottone has been great with putting our mind at ease, having patience and starting to rebuild confidence.",
  date: "Grade 7"
}, {
  id: 16,
  name: "Rakesh B.",
  location: "Parent",
  text: "Two of my kids have been taught by Robert. The younger one had a chaotic math experience due to COVID, and she needed to fill in gaps. The summer before her high school freshman year Robert guided her through Richard Rusczyk's Introduction to Algebra, a challenging text. Robert was so patient and charming that our daughter never complained about a tutoring session, though she was meeting four times a week over her summer. Her math skills leaped. Our older one had Robert as a math teacher for an advanced algebra class her high school sophomore year. She audited a multivariable calculus class at UC Berkeley before her first year of college and said she was ahead of the game in part because of what Robert had taught her three years ago. She also says that what Robert taught her was part of the reason she tested into the most difficult math courses on Harvard's placement exam. Both kids have found Robert challenging and charming; and appreciate his rigor, clarity and patience. Robert is a fantastic teacher.",
  date: "Grade 9"
}, {
  id: 17,
  name: "Enrique V.",
  location: "Student",
  text: "By working with Mr. Cottone, I have seen my college calculus grades on exams improve greatly. I went from a C in my previous test to an A on my last test. I highly recommend you hire Mr Cottone if you’re struggling with math concepts!",
  date: "College"
}, {
  id: 18,
  name: "John M.",
  location: "Parent",
  text: "Mr. Cottone tutored my daughter on AP Calculus in preparation of her big AP test. She enjoyed her interaction with Mr. Cottone and he was able to help her achieve a high score on the AP Exam. I would definitely recommend.",
  date: "Grade 12"
}, {
  id: 19,
  name: "Jane N.",
  location: "Parent",
  text: "My son recently started working with Mr. Cottone and immediately he started seeing better results. Mr. Cottone explains problems in a way my son easily grasps, unlike his teacher. I wish he could be his teacher instead! With Mr. Cottone’s involvement I feel assured my son is on an upward trajectory.",
  date: "Grade 10"
}, {
  id: 20,
  name: "Sean R.",
  location: "Parent",
  text: "Mr. Cottone has been a pleasure to work with, my son has improved considerably in a short time with the time spent. He is understanding the math concepts that he is missing in class and improving in all areas of his math curriculum. Aside from just the tutoring, Mr. Cottone has been easy to work with on scheduling changes and understanding life happens. We appreciate his understanding.",
  date: "Grade 6"
}, {
  id: 21,
  name: "Kathy M.",
  location: "Parent",
  text: "My daughter was struggling with the material in her Pre-Calc class and she was also struggling with the teaching method of her instructor. I'm very happy to say that Mr. Cottone has been incredibly helpful to her, presenting the material in a way that she finds easier to understand. We are grateful to have found him and he has been very flexible to work with her when she needs it.",
  date: "Grade 11"
}, {
  id: 22,
  name: "Mark K.",
  location: "Parent",
  text: "Robert is extremely professional and displayed a level of patience and understanding with my daughter that exceeds that of other tutors we have used. I highly recommend his services.",
  date: "Grade 8"
}, {
  id: 23,
  name: "Kathy B.",
  location: "Parent",
  text: "Robert tutored my son right before some important exams for AP calculus! He was professional, caring, organized and helped my son improve his grades! We highly recommend him!",
  date: "Grade 12"
}, {
  id: 24,
  name: "Noa P.",
  location: "Student",
  text: "Mr. Cottone’s patience, infectious love of math, warmth, and humor made class something I always looked forward to for the year and a half he taught me. Whenever I needed help, he effortlessly figured out the precise part of a problem or topic that I hadn’t grasped. Then he had ready as many different ways of thinking about the problem as I needed to deeply understand it. I highly recommend Mr. Cottone for a sharp, thoughtful tutor who won’t give up until you come away with a true understanding of math (and appreciation for the fun of it too!).",
  date: "Grade 9"
}, {
  id: 25,
  name: "Om M.",
  location: "Student",
  text: "Mr. Cottone is my favorite teacher of all time! He is incredibly knowledgeable about math: I vividly remember his thorough explanations of complex problems during class. When I would walk into the math office, I would often see Mr. C seated at the table, patiently working through a concept with one of his students. I emerged from Mr. Cottone's class with a strong foundation of geometrical concepts that helped me succeed in later classes. At the same time, Mr. Cottone is a very engaging teacher. He cracks funny jokes, discusses life beyond the classroom, and creates genuine relationships with his students. Math was always fun with Mr. Cottone: he pushes against the conventional narrative that math has to be serious and unenjoyable. He not only teaches you the material, but helps you to enjoy the process of learning it. Some of my best memories of high school were in Mr. Cottone's classroom. In fact, a story from one class became a central piece of my college essay! He inspired me seek two summer teaching opportunities shortly after graduating high school. I cannot recommend Mr. Cottone enough — he has all the qualities that you could ever wish for in an amazing teacher.",
  date: "Grade 9"
}, {
  id: 26,
  name: "Kimberley C.",
  location: "Student",
  text: "Mr. Cottone is an excellent tutor. He has patience and is very thorough in his field of math. He explains the material very well and will go over the problem until you understand it. You will not be disappointed in hiring him!",
  date: "College"
}, {
  id: 27,
  name: "Hannah K.",
  location: "Student",
  text: "I really enjoyed having Mr. Cottone as my math teacher! He made class very fun and I learned a lot. He really cares about his students and was very accessible if we had questions.",
  date: "Grade 10"
}];
export default function WhatYourNeighborsSay() {
  return <section data-section-id="235126" id="voices-of-success" className="relative bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] dark:opacity-[0.08]">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680106/img/mathematical_geometric_pattern.png)] bg-cover bg-center bg-no-repeat mix-blend-multiply" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary tracking-tight mb-4">
              Voices of Success
            </h2>
            <p className="text-lg text-muted-foreground font-sans">
              Discover how our personalized, master-level instruction empowers students to master complex mathematics and build lasting academic confidence.
            </p>
          </div>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4 md:-ml-6">
            {reviews.map((review, i) => <CarouselItem key={review.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <Card className="h-full flex flex-col bg-card backdrop-blur-md border-border/50 shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex gap-1">
                        {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="size-5 fill-secondary text-secondary" />)}
                      </div>
                      <span className="text-xs text-primary font-mono font-semibold">
                        {review.date}
                      </span>
                    </div>
                  </CardHeader>
                  <CardContent className="flex-grow pb-6">
                    <p className="text-primary font-serif leading-relaxed italic !text-sm">
                      "{review.text}"
                    </p>
                  </CardContent>
                  <CardFooter className="pt-0 flex flex-col items-start gap-4 border-t border-border/30 mt-auto pt-6">
                    <div className="flex items-center justify-between w-full">
                      <div>
                        <p className="font-default font-bold text-primary text-lg">
                          {review.name}
                        </p>
                        <div className="flex items-center text-muted-foreground mt-1">
                          <MapPin className="size-3.5 mr-1.5 text-secondary" />
                          <span className="text-sm font-sans">
                            {review.location}
                          </span>
                        </div>
                      </div>
                      <Badge variant="secondary" className="bg-muted text-primary border-border rounded-lg">
                        <ShieldCheck className="size-3 mr-1" />
                        Verified Review
                      </Badge>
                    </div>
                  </CardFooter>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <div className="flex justify-end gap-2 mt-8 md:hidden">
            <CarouselPrevious className="relative inset-auto size-10 translate-y-0 translate-x-0 bg-background border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground rounded-lg" />
            <CarouselNext className="relative inset-auto size-10 translate-y-0 translate-x-0 bg-background border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground rounded-lg" />
          </div>
          <div className="hidden md:block">
            <CarouselPrevious className="-left-12 bg-background border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground shadow-md rounded-lg" />
            <CarouselNext className="-right-12 bg-background border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground shadow-md rounded-lg" />
          </div>
        </Carousel>
      </div>
    </section>;
}